import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react";
import { RiEyeFill, RiEyeOffFill } from "@remixicon/react";
import { useEffect, useState } from "react";

interface Props extends InputProps {
  inputValue?: string | undefined;
  placeholder?: string;
  onConfirm: (inputValue: string) => void;
}

export const PasswordInput = ({
  inputValue,
  placeholder,
  onConfirm,
  ...rest
}: Props) => {
  const [toggle, setToggle] = useState<string>("hide");
  const [data, setData] = useState<string>(inputValue?.toString() ?? "");

  useEffect(() => {
    inputValue ? setData(inputValue.toString()) : setData("");
  }, [inputValue]);

  const togglePassword = () => {
    toggle === "show" ? setToggle("hide") : setToggle("show");
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData(e.target.value);
    onConfirm(e.target.value);
  };

  return (
    <InputGroup size={["sm", null, "md"]} {...rest}>
      <Input
        name="password"
        type={toggle === "show" ? "text" : "password"}
        placeholder={!!placeholder ? placeholder : "********"}
        onChange={handleChange}
        value={data}
      />
      <InputRightElement>
        <IconButton
          bg={"transparent"}
          _hover={{ bg: "transparent" }}
          size={["sm", null, "md"]}
          icon={
            toggle === "hide" ? (
              <Icon as={RiEyeFill} opacity={0.6} />
            ) : (
              <Icon as={RiEyeOffFill} />
            )
          }
          aria-label="togglePassword"
          onClick={togglePassword}
        />
      </InputRightElement>
    </InputGroup>
  );
};
